export default {
    bill : {
      availableCredit:'Available Credit',
      addFunds:'Add Funds',
      month:'Cumulative Consumption This Month',
      history:'History',
      order:'Order',
      startDate:'start date',
      endDate:'end date',
      search:'Search',
      searchNumber:'Enter Transaction Number',
      download:'Download',
      historyList:{
        number:'Serial Number',
        tNumber:'Transaction Number',
        date:'Date',
        type:'Type',
        TChannel:'Transaction Channel',
        amount:'Amoumt',
        balance:'Balance',
      },
      orderList:{
        tNnmber:'Transaction Number',
        zone:'Zone',
        oType:'Order Type',
        pType:'Product Type',
        charge:'Charge',
        status:'Status',
        time:'Order / Payment Time',
        actions:'Actions',
        view:'View',
        pay:'Pay',
      },
      pay:{
        title:'Pay Order',
        detail:'Order Details',
        tNumber:'Transaction Number: ',
        zone:'Zone: ',
        pType:'Product Type:',
        oType:'Order Type: ',
        time:'Order Time:',
        price:'Price:',
        cancel:'Cancel',
        pay:'Pay',
      },
      view:{
        title:'View Order',
        detail:'Order Summary',
        tNumber:'Order Number:',
        oType:'Order Type: ',
        otime:'Order Time:',
        ptime:'Payment Time:',
        odetail:'Order Details',
        product:'Product',
        num:'Quantuty',
        config:'Config',
        price:'Price',
        pamount:'pay_amount',
      },
      recharge:{
       title:'Make a Payment',
       pa:'Payment Amount:',
       pm:'Payment Method:',
       cancel:'Cancel',
       pay:'Pay',
      },
      paying:{
        title:'Message',
        desc:'Please make a payment on the newly opened page.',
        after:'After the payemnt is complete, click the button below depending on your situation.',
        success:'Paid successfully',
        failed:'Paid failed',
      }
    },
    user :{
      myProfiletitle:'My Profile',
      billingTitle:'Billing',
      operationLogTitle:'Operation Log',
      profile:'User Profile',
      log:'Operation Log',
      detail:'Your Details',
      name:'Nickname:',
      cname:'Change Nickname',
      newName:'New Nickname:',
      confirm:'Confirm the Change',
      curPwd:'Curent Password:',
      cPwd:'Change Password',
      curPwdDesc:'Please enter the original password here',
      newPwd:'New Password:',
      newPwdDescFirst:'Please enter a new password here',
      newPwdDescTwo:'Please enter the new password again here',
      email:'Email:',
      cemail:'Change Email',
      nemail:'New Email:',
      send:'Send Confirmation',
      reSend:'Retrieve after',
      code:'Verification Code',
      error:{
        emailAddress:'Please enter email address',
        emailFormat:'Email format error',
        nickname:'Please Enter Nickname',
        nicknameForamt:'Nickname format error',
        password:'Please enter a new password',
        passwordFormat:'Password format error',
        passwordTwo:'Please enter the new password again',
      },
      logList:{
        'obj':'Operation Object',
        'LType':'Log Type',
        'LTypelist':[
          { text: 'Product', value: 'product' },
          { text: 'Account', value: 'account' },
          { text: 'Order', value: 'order' },
          { text: 'Other', value: 'other' },
        ],
        'pname':'Product Name',
        'oname':'Operation Name',
        'otime':'Operating Time',
      },
      cUs:'Contact Us',
      ask:'Click to ask your questions or tell us your advice',
      feed:{
        title:'Feedback',
        type:'Feedback Type:',
        fTitle:'Feedback Title:',
        desc:'Description:',
        email:'Email:',
        cancel:'Cancel',
        submit:'Submit',
        typeList:{
          ecc:'Elastic Compute Cloud',
          bms:'Bare Metal Server',
          mysql:'RDS for MySQL',
          disk:'Disk',
          elb:'Elastic Load Balancer',
          ip:'Anti-DDoS Ip',
          ssl:'SSL Certificate',
        },
      },
      oauth:{
        app:'Authorized Apps:',
        auth:'Authorize',
        unAuth:'Remove',
        tip1:'Remove',
        tip2:'account',
        tip3:'You will not be able to sign in to your Yisu Cloud Account with Sign in with this App if you remove it. Remove anyway?',
        tip4:'Add your Sign in with this App account to be able to sign in to your Yisu Cloud Account with Sign in with this App.',
        tip5:'Authorize your',
        cancel:'Cancel',
      }
    },
  }



// WEBPACK FOOTER //
// ./src/lang/en/user.js